import { AfterContentInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BrandType } from '../../models/request-and-responses/rest-api/enums/brandType';
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-brand-logo',
    templateUrl: './brand-logo.component.html',
    styleUrls: ['./brand-logo.component.css'],
    providers: [NgbPopoverConfig] // add NgbPopoverConfig to the component providers
})
export class BrandLogoComponent implements OnInit, AfterContentInit {
    @ViewChild('ajo') ajoTemplateRef: TemplateRef<any>;
    @ViewChild('ajoEnergia') ajoEnergiaTemplateRef: TemplateRef<any>;
    @ViewChild('patavium') pataviumTemplateRef: TemplateRef<any>;

    @ViewChild('notMapped') notMappedTemplateRef: TemplateRef<any>;
    @ViewChild('noOne') noOneTemplateRef: TemplateRef<any>;

    @Input() brands: BrandType[];

    brandTemplateRefs: TemplateRef<any>[];

    constructor(config: NgbPopoverConfig) {
        config.placement = 'right';
        config.autoClose = 'outside';
    }

    ngOnInit(): void {
        this.brandTemplateRefs = [];
    }

    private get thereAreNotBrands(): boolean {
        return this.brands == null || this.brands.length === 0;
    }

    get thereIsOnlyOneBrandTemplateRef(): boolean {
        return this.brandTemplateRefs.length === 1;
    }

    ngAfterContentInit(): void {
        if (this.thereAreNotBrands) {
            this.brandTemplateRefs.push(this.noOneTemplateRef);
        } else {
            for (const brand of this.brands) {
                switch (brand) {
                    case BrandType.Ajo:
                        this.brandTemplateRefs.push(this.ajoTemplateRef);
                        break;
                    case BrandType.AjoEnergia:
                        this.brandTemplateRefs.push(this.ajoEnergiaTemplateRef);
                        break;
                    case BrandType.Patavium:
                        this.brandTemplateRefs.push(this.pataviumTemplateRef);
                        break;
                    case BrandType.UniEnergia:
                    default:
                        this.brandTemplateRefs.push(this.notMappedTemplateRef);
                        break;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/brand-logo/brand-logo.component.ts